export enum ActivePage {  
  Other,
  Orders,
  Operations,
  Templates,
  ProductionOverview
}